<template>
    <div class="pt-3 pb-3">
        <div class="card">
            <div class="card-body">
                <div class="row">
                    <div class="col-sm-12 text-center" style="color: red;">
                        <img src="@/assets/error-404.png" id="error" alt="">
                        <h2>ไม่พบข้อมูล!</h2>
                        <h4>กรุณากดปุ่ม Refresh</h4>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12">
                        <button type="button" class="btn btn-danger btn-block" @click="toBack">Refresh Click!</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
export default {
    data(){
        return {

        }
    },

    created(){
       
    },

    watch: {

    },

    methods:{
        toBack(){
            this.$router.push({name: 'registerform2'});
        },
    }
}
</script>

<style scoped>
    #error {
        margin-left: auto;
        margin-right: auto;
        display: block;
        width: 200px;
        height: 200px;
    }
</style>